/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminStockAdjustLocationOptionsResVo } from './AdminStockAdjustLocationOptionsResVo';
import {
    AdminStockAdjustLocationOptionsResVoFromJSON,
    AdminStockAdjustLocationOptionsResVoFromJSONTyped,
    AdminStockAdjustLocationOptionsResVoToJSON,
    AdminStockAdjustLocationOptionsResVoToJSONTyped,
} from './AdminStockAdjustLocationOptionsResVo';

/**
 * 
 * @export
 * @interface ResponseAdminStockAdjustLocationOptionsResVo
 */
export interface ResponseAdminStockAdjustLocationOptionsResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseAdminStockAdjustLocationOptionsResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseAdminStockAdjustLocationOptionsResVo
     */
    message?: string;
    /**
     * 
     * @type {AdminStockAdjustLocationOptionsResVo}
     * @memberof ResponseAdminStockAdjustLocationOptionsResVo
     */
    data?: AdminStockAdjustLocationOptionsResVo;
}

/**
 * Check if a given object implements the ResponseAdminStockAdjustLocationOptionsResVo interface.
 */
export function instanceOfResponseAdminStockAdjustLocationOptionsResVo(value: object): value is ResponseAdminStockAdjustLocationOptionsResVo {
    return true;
}

export function ResponseAdminStockAdjustLocationOptionsResVoFromJSON(json: any): ResponseAdminStockAdjustLocationOptionsResVo {
    return ResponseAdminStockAdjustLocationOptionsResVoFromJSONTyped(json, false);
}

export function ResponseAdminStockAdjustLocationOptionsResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseAdminStockAdjustLocationOptionsResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : AdminStockAdjustLocationOptionsResVoFromJSON(json['data']),
    };
}

export function ResponseAdminStockAdjustLocationOptionsResVoToJSON(json: any): ResponseAdminStockAdjustLocationOptionsResVo {
    return ResponseAdminStockAdjustLocationOptionsResVoToJSONTyped(json, false);
}

export function ResponseAdminStockAdjustLocationOptionsResVoToJSONTyped(value?: ResponseAdminStockAdjustLocationOptionsResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': AdminStockAdjustLocationOptionsResVoToJSON(value['data']),
    };
}

